// The pipeline's tube on its bent path, cubes standing on its walls, lit from one side. The pitch (width + spacing) is locked at one tunnel radius (100 su), one ring per radius.
export default {
	name: 'voxel_tunnel',
	label: 'Voxel Tunnel',
	description: 'Flight down a winding round tunnel',

	expose: {
		speed: {
			tip: 'Travel speed; negative travels backwards',
			step: 0.05,
			period: 1,
			initial: 1,
			minimum: -8,
			maximum: 8,
		},
		bend: {
			tip: 'How strongly the tunnel curves',
			initial: 1,
		},
		bend_angle: {
			tip: 'Which way the tunnel curves, round the view',
			initial: 90,
		},
		wander: {
			tip: 'Swings the curve from side to side down the tunnel; 0 curves one way forever',
			initial: 0.5,
		},
		bend_roll: {
			tip: 'Turns the way the tunnel curves as it goes',
			initial: 0,
		},
		rounding: {
			tip: 'Square tunnel to round; the round wall hides the corner cubes',
			initial: 0,
		},
		relief: {
			tip: 'Height of the cubes on the walls; 0 is a smooth tunnel',
			initial: 1,
		},
		cube_size: {
			tip: 'Side of the largest cubes',
			initial: 50,
		},
		cube_levels: {
			tip: 'How many cube sizes, each half the one before',
			initial: 3,
		},
		cube_fill: {
			tip: 'Share of the largest cells raised',
			initial: 0.5,
		},
		cube_seed: {
			tip: 'Another arrangement of cubes',
			initial: 1,
		},
		light: {
			tip: 'Shading of the walls; 0 is flat',
			initial: 1,
		},
		light_angle: {
			tip: 'Where the light comes from, round the tunnel',
			initial: 30,
		},
		fog: {
			tip: 'How soon the tunnel fades into the ground',
			initial: 1,
			maximum: 4,
			step: 0.05,
		},
		rings: {
			tip: 'Strength of the bands running down the tunnel',
			initial: 1,
		},
		ring_speed: {
			tip: 'Slides the bands along the tunnel, bands per second; negative brings them toward you',
			initial: 0,
			period: 1,
		},
		color: {
			tip: 'First wall palette colour',
			initial: '#ff2fa8',
		},
		color_b: {
			label: 'Color 2',
			tip: 'Last wall palette colour',
			initial: '#1fe0c0',
		},
		spread: {
			tip: 'Number of colours from Color to Color 2',
			initial: 3,
		},
		repeat: {
			tip: 'Ramp restarts the palette, Mirror walks back',
			initial: 1,
		},
		wash: {
			tip: 'Scrolls the palette down the tunnel, colours per second',
			initial: 0,
			period: 1,
		},
		ground: {
			tip: 'Band and fog colour, and behind the walls',
			initial: '#e02b4d',
		},
	},

	lock: {
		enclose: 1,
		tunnel: 1,
		fit: 0,
		width: 100,
		spacing: 0,
		twist: 1,
		perspective: 2,
		cube_split: 0.5,
		cube_split_fill: 0.6,
		cube_corner: 0.5,
		cube_cluster: 0.5,
		cube_cluster_size: 6,
	},
	range: {
		tunnel: [0, 1],
		width: [0.1, 100],
		spacing: [0, 100],
		pan: [-1000, 1000],
		perspective: [1, 2],
	},
}
